import { Moment } from 'moment';
import { Dates } from '../../organisms/SearchForm/SearchForm.types';

export type SelectedDateType = 'startDate' | 'endDate' | 'customDate' | null;

export type DateObject = Moment;

export type CalendarProps = CalendarOptions & {
  mode?: 'single' | 'range';
  variation: string;
  nightLabel: string;
  nightsLabel: string;
  setDates: (startDate: DateObject | null, endDate: DateObject | null, selectedDateType: SelectedDateType) => void;
  setInitialDates?: (
    startDate: DateObject,
    endDate: DateObject,
    initialStartDate: DateObject,
    initialEndDate: DateObject,
    selectedDateType: SelectedDateType
  ) => void;
  selectedDateType?: SelectedDateType;
  selectedStartDate?: DateObject | null;
  selectedEndDate?: DateObject | null;
  isDateRangeFixed?: boolean;
  rangeStartDate?: DateObject | null;
  rangeEndDate?: DateObject | null;
  setDefaultDates?: boolean;
  isCalendarClosed?: boolean;
  isThereTwoDateInputBox?: boolean;
  isPastDateSelectionDisabled?: boolean;
  enableFromPastDate?: Date;
};

export type CalendarOptions = {
  shortWeekdayInitials?: string[];
  shortWeekdayNames?: string[];
  longWeekdayNames?: string[];
  shortMonthNames?: string[];
  longMonthNames?: string[];
};

export type CalendarState = {
  startDate: DateObject | null;
  endDate: DateObject | null;
  selectedDateType: SelectedDateType;
};

export type DateLabels = Dates &
  CalendarOptions & {
    done?: string;
    doneAriaLabel?: string;
    doneTrackLocation?: string;
    doneTrackDescription?: string;
    cancel?: string;
    cancelAriaLabel?: string;
  };

export type PlatformCalendarRef = {
  setFromEndDate?: (startDate?: Date, endDate?: Date) => void;
  setDefaultMonth?: (date?: Date) => void;
};

export enum CalendarTabValue {
  MULTIPLE = 'multiple',
  SINGLE = 'single',
}

export type CalendarSelectionStateByTab = Record<CalendarTabValue, CalendarState>;

export type TabDatesSelection = {
  startDate: DateObject | null;
  endDate: DateObject | null;
  selectedDateType: SelectedDateType;
};

export type BaseCalendarProps = {
  dates: DateLabels;
  selectedStartDate?: DateObject | null;
  selectedEndDate?: DateObject | null;
  isDateRangeFixed?: boolean;
  rangeStartDate?: DateObject | null;
  rangeEndDate?: DateObject | null;
  setDefaultDates?: boolean;
  showErrorMessage?: boolean;
  errorMessage?: string;
  isPastDateSelectionDisabled?: boolean;
  enableFromPastDate?: Date;
  calendarTab?: CalendarTabValue;
  onCalendarTabChange?: (tab: CalendarTabValue) => void;
  onChange?: (dates: string, startDate: string, endDate: string) => void;
  hideDatesBadge?: boolean;
};
